import { Checkbox } from 'antd'

import { ReactComponent as FileIcon } from 'assets/icons/doc.svg'
import { buildDateString } from 'utils/dates'
import Styles from './ImportModal.module.scss'

export interface GoogleDriveFile {
  id: string
  name: string
  modifiedTime: string
}

interface ImportFileRowProps {
  file: GoogleDriveFile
  selected: boolean
  onCheck: (file: GoogleDriveFile) => void
  selectOne: boolean
}

const ImportFileRow = ({ file, selected, onCheck, selectOne }: ImportFileRowProps) => {
  const { id, name, modifiedTime } = file

  return (
    <div onClick={() => onCheck(file)} className={Styles.importFileRow}>
      <div className={Styles.fileRowLeft}>
        {!selectOne && <Checkbox id={id} defaultChecked={selected} onChange={() => onCheck(file)} checked={selected} />}
        <div className={Styles.fileIcon}>
          <FileIcon />
        </div>
        <div className={Styles.docName}>{name}</div>
      </div>
      <div className={Styles.fileRowRight}>{buildDateString(modifiedTime, true, true)}</div>
    </div>
  )
}

export default ImportFileRow
